import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngxs/store';
import { DossierState } from '@stores/dossier/dossier.state';
import { Dossier, DossierStatusEnum } from '@wizbii/models';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class DataValidatedGuard implements CanActivate {
  constructor(private readonly store: Store, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const hasDossierWithDataValidated$ = this.store.select(DossierState.dossiers).pipe(
      filter((dossiers) => !!dossiers),
      map((dossiers: Dossier[]) =>
        dossiers.filter((dossier) => dossier?.revision?.status === DossierStatusEnum.DataValidated)
      )
    );

    return hasDossierWithDataValidated$.pipe(
      switchMap((dossiers) => {
        if (dossiers.length > 0 && dossiers[0]?.suggestionId) {
          this.router.navigate(['/', FeaturesRoutingEnum.DepotForm, dossiers[0]?.suggestionId, 'step', 'complete']);
          return of(false);
        }
        return of(true);
      })
    );
  }
}
